import { ActionTypes, TypeKeys } from '../actions/experiments'

export interface IExperimentState {
  isLoadingVariant: boolean
  variant: string
}

export interface IExperimentsState {
  readonly [experimentId: string]: IExperimentState | boolean
}

const initialState: IExperimentsState = {
  experimentsReady: false
}

export default (
  state: IExperimentsState = initialState,
  action: ActionTypes
) => {
  switch (action.type) {
    case TypeKeys.EXPERIMENT_DATA_RECEIVED:
      return {
        ...state,
        [action.payload.experiment_id]: {
          isLoadingVariant: false,
          variant: action.payload.variant
        }
      }
    case TypeKeys.EXPERIMENTS_ERROR:
      return {
        ...state,
        [action.payload.experiment_id]: {
          isLoadingVariant: false
        }
      }
    case TypeKeys.EXPERIMENTS_READY:
      return {
        ...state,
        experimentsReady: action.payload
      }
    default:
      return state
  }
}
